import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/frames'
import { FullDateDeliveryIndicatorContainer } from '@grandvisionhq/www-next/slot-components/FullDateDeliveryIndicatorContainer'
import { PromoteInstallmentsGraphContainer } from '@grandvisionhq/www-next/slot-components/PromoteInstallmentsGraphContainer'
import { RxGlassesConfiguratorGraphContainer } from '@grandvisionhq/www-next/slot-components/RxGlassesConfiguratorGraphContainer'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { ReserveInStoreGraphContainer } from '../../../components/slot-components/reserve-in-store-graph-container'
import { SoclozScript } from '../../../components/slot-components/socloz-script'
import {
  commonSpecifications,
  getDeliveryIndicatorConfig,
  graphPromoteInstallmentsConfiguration,
} from '../../../configuration'

const slots: Props['slots'] = {
  AfterCTA: ReserveInStoreGraphContainer,
  AfterPrice: () => (
    <PromoteInstallmentsGraphContainer opcoConfiguration={graphPromoteInstallmentsConfiguration} />
  ),
  Configurator: RxGlassesConfiguratorGraphContainer,
  DynamicDeliveryIndicator: FullDateDeliveryIndicatorContainer,
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()

  return (
    <>
      <Page
        {...props}
        slots={slots}
        bookAppointmentRouteConfig={{ route: 'stores.overview' }}
        deliveryIndicatorConfig={deliveryIndicatorConfig}
        specificationConfiguration={commonSpecifications}
      />
      <SoclozScript />
    </>
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage)
